import React from "react";
import { Link } from "react-router-dom";

const fmtShort = (s) => new Date(`${s}T00:00:00`).toLocaleDateString("it-IT", { day: "numeric", month: "short" });
const REL = { precedente: "Precedente", selezionata: "Settimana selezionata", successiva: "Successiva" };

// Previous / selected / next work weeks (Thu→Wed) with their Piano settimana description
export function WeeklyConditions({ weeks }) {
    const sel = weeks.filter((w) => w.relation === "selezionata");
    const prev = weeks.filter((w) => w.relation === "precedente").slice(-1);
    const next = weeks.filter((w) => w.relation === "successiva").slice(0, 1);
    const shown = [...prev, ...sel, ...next];
    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-testid="tm-weekly-conditions">
            {shown.map((w) => (
                <div key={w.week_start} data-testid={`tm-week-${w.week_start}`}
                    className={`rounded-md border p-4 ${w.relation === "selezionata" ? "bg-white border-neutral-900" : "bg-neutral-50 border-neutral-200"}`}>
                    <div className="text-[10px] uppercase tracking-widest font-semibold text-neutral-500">{REL[w.relation]}</div>
                    <div className="text-xs text-neutral-500 mb-2">{fmtShort(w.week_start)} → {fmtShort(w.week_end)}</div>
                    {w.plans.length === 0 && <div className="text-sm text-neutral-400 italic">Nessun piano settimanale</div>}
                    {w.plans.map((p) => (
                        <div key={p.id} className="text-sm">
                            <Link to={p.link} className="text-xs font-medium text-neutral-700 hover:underline">{p.title}</Link>
                            <div className={`mt-0.5 whitespace-pre-wrap ${p.condition ? "text-neutral-900" : "text-neutral-400 italic"}`}>{p.condition || "Descrizione vuota"}</div>
                            {p.plan && <div className="mt-1 text-xs text-neutral-500 line-clamp-3" data-testid={`tm-week-plan-${p.id}`}>{p.plan}</div>}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
